export const defaultOrder = "↑"; // ↑ ↓
export const defaultMaxScore = "100.0";
export const defaultRequirement = "60.0";
export const defaultMinGrade = "1.0";
export const defaultMaxGrade = "7.0";
export const defaultPassingGrade = "4.0";
export const defaultIncrement = "1.0";